import React from 'react';
import { Box, Divider, IconButton, makeStyles, MoreVert, StatusDisplay, Typography } from 'housecall-ui';
import { HCPTheme } from 'housecall-ui/dist/Theme/Theme';

const useStyles = makeStyles((theme: HCPTheme) => ({
  content: {
    flexGrow: 1,
  },
  statusIcon: {
    marginLeft: '-4px !important',
  },
  statusLabel: {
    color: theme.palette.text.secondary,
    lineHeight: theme.typography.caption.lineHeight,
    whiteSpace: 'pre-line',
  },
  icon: {
    transform: 'rotate(90deg)',
  },
  optionsButton: {
    alignSelf: 'flex-start',
  },
  newLine: {
    whiteSpace: 'pre-line',
  },
}));

export type ReminderContentProps = {
  title: string;
  text: string;
  onOptionsOpen: (event: React.MouseEvent<HTMLButtonElement>) => void;
  editable: boolean;
};

export const ReminderContent = ({ title, text, onOptionsOpen, editable }: ReminderContentProps) => {
  const classes = useStyles();

  return (
    <>
      <Box p={2} pl={8} pr={0} display="flex" width="100%" justifyContent="space-between">
        <Box>
          <StatusDisplay
            classes={{
              icon: classes.statusIcon,
              label: classes.statusLabel,
            }}
            status=""
            color="orange"
            label={`Reminder - ${title}`}
          />
          <Typography data-testid="requestGuide__reminderTitle" variant="subtitle1" className={classes.newLine}>
            {text}
          </Typography>
        </Box>
        {editable && (
          <IconButton className={classes.optionsButton} data-testid="request-card-options" onClick={onOptionsOpen}>
            <MoreVert />
          </IconButton>
        )}
      </Box>
      <Divider />
    </>
  );
};
